import Axios from "axios";
import { objectToFormData } from "object-to-formdata";
import service_explorers from "@/services/global/service_explorers";
import model_pkcProcess, { getAllFields } from "@/constants/models/pkc/model_pkcProcess";
import service_processes from "@/services/service_processes";
import model_process from "@/constants/models/model_process";
import { resourceAction } from "@/services/service_resource_manager";

export default {
  async enableOrUpdateProcess(newProcess, isNew) {
    let form_data_object = objectToFormData(newProcess, { indices: true });
    const url = isNew ? "app-center/pkc/processes" : "app-center/pkc/processes/" + newProcess[model_pkcProcess.ID];
    return Axios
      .post(
        process.env.VUE_APP_ENDPOINT +
        url,
        form_data_object
      )
      .then((response) => {
        console.log(response);

      });

  },
  async getPKCProcess(pkc_process_code) {
    const processesFound = await service_explorers.find("app-center/pkc/processes", getAllFields(), { [model_pkcProcess.PROCESS_CODE]: pkc_process_code }, null);
    if (processesFound && processesFound.results && processesFound.results.length === 1) {
      return processesFound.results[0];
    }
    return null;
  },

  async initializeDirectory(processPath) {
    await resourceAction("create_folder", processPath + "/DOCUMENTS");
    await resourceAction("create_folder", processPath + "/DOCUMENTS/CHECKLISTS");
    await resourceAction("create_folder", processPath + "/DOCUMENTS/BRIEFINGS");
    await resourceAction("create_folder", processPath + "/DOCUMENTS/RESOURCES");
    await resourceAction("create_folder", processPath + "/DOCUMENTS/NOTES");

    window.location.reload();
  },
  async getPKCProcesses(fields, filters, options) {
    return service_explorers.find("app-center/pkc/processes", fields, filters, options);
  },
  async getBriefings(fields, filters, options) {
    return service_explorers.find("app-center/pkc/briefings", fields, filters, options);
  },
  async createBriefing(user_pmo, process_code) {
    let form_data_object = objectToFormData({
      user_pmo,
      process_code
    }, { indices: true });
    console.log("createBriefing", user_pmo, process_code);
    return Axios
      .post(
        process.env.VUE_APP_ENDPOINT +
        "app-center/pkc/briefings",
        form_data_object
      )
      .then((response) => {
        console.log(response);

      });
  },
  async updateBriefing(briefing_id, data) {
    let form_data_object = objectToFormData(data, { indices: true });
    return Axios
      .post(
        process.env.VUE_APP_ENDPOINT +
        "app-center/pkc/briefings/" + briefing_id,
        form_data_object
      )
      .then((response) => {
        console.log(response);

      });

  },
  async getPKCChecklist(fields, filters, options) {
    return service_explorers.find("app-center/pkc/checklists", fields, filters, options);
  },
  async createChecklist(user_operation, process_code) {
    let form_data_object = objectToFormData({
      user_operation,
      environment: "production",
      process_code
    }, { indices: true });
    return Axios
      .post(
        process.env.VUE_APP_ENDPOINT +
        "app-center/pkc/checklists",
        form_data_object
      )
      .then((response) => {
        console.log(response);

      });
  },
  async updateChecklist(checklist_id, data) {
    const { normalizeChecklistData } = require("@/utils/checklist_utils");

    const normalizedData = normalizeChecklistData(data);

    let form_data_object = objectToFormData(normalizedData, { indices: true });
    return Axios
      .post(
        process.env.VUE_APP_ENDPOINT +
        "app-center/pkc/checklists/" + checklist_id,
        form_data_object
      )
      .then(() => {
      });

  },
  async getProcessManagementContextByProcessCode(processCode) {
    // Fetch process info
    const response = await service_processes.getProcessInfo(processCode);
    const processInfo = Object.assign({}, response.data.extra);
    // Fetch PKC process info
    const pkcResponse = await this.getPKCProcesses(getAllFields(), { [model_pkcProcess.PROCESS_CODE]: processCode });
    console.log("Damelo todo papi", pkcResponse);
    const processPKCInfo = pkcResponse && pkcResponse.results ? pkcResponse.results[0] : null;
    // Compute process path
    const processPath = processInfo ? `${processInfo[model_process.MASTER_ACCOUNT_CODE]}/${processInfo[model_process.SUB_ACCOUNT_CODE]}/${processInfo[model_process.PROJECT_CODE]}/${processInfo[model_process.CODE]}` : null;
    return { processInfo, processPKCInfo, processPath };
  },
  async getProcessManagementContextByChecklistId(checklistId) {
    // Get checklist to know the process code
    const idFilter = isNaN(checklistId) ? checklistId : Number(checklistId);
    const checklistResp = await service_explorers.find("app-center/pkc/checklists", ["id", "process_code"], { id: idFilter }, {
      rpp: 1,
      page: 1
    });
    const results = checklistResp && checklistResp.results ? checklistResp.results : [];
    if (!results.length) {
      return { processInfo: null, processPKCInfo: null, processPath: null };
    }
    const processCode = results[0]["process_code"];
    return this.getProcessManagementContextByProcessCode(processCode);
  }
};